import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { PROGRAM_ADDED_MESSAGE } from '../../static-content';
import AlertMessage from '../AlertMessage';
import YouTube from 'react-youtube';
import { getWeekDayInitial } from '../../helpers';
import { COLORS } from '../../styles/colors';
import List from '@material-ui/core/List';
import WorkoutPreviewButton from '../WorkoutPreviewButton';
/**
 * Info
 */
export class Info extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false
  }
  componentDidMount() {
    this.props.fetchInfo(this.props.editId).then(() => {
      this.setState({
        ...this.state,
        dataLoaded: true,
        expanded: 1
      })
    });
  }
  displayDayInfo(day) {
    const { programWorkouts } = this.props;
    switch (day.type) {
      case "workout":
        const workout = programWorkouts[day.workoutId] ? programWorkouts[day.workoutId] : null
        if (workout) {
          return workout.name;
        } else {
          return "Unknown Workout of " + day.workoutId;
        }
      case "rest":
        return day.message ? "Rest Day: " + day.message : 'Rest Day';
      case "cardio":
        return day.message ? "Cardio Day: " + day.message : 'Please insert Cardio Day Information';
      default:
        return "...";
    }
  }

  getProgramLevel(level) {
    switch (String(level)) {
      case '1':
        return 'Beginner';
      case '2':
        return 'Intermediate';
      case '3':
        return 'Advanced';
      default:
        return '';
    }
  }

  _onReady(event) {
		// access to player in all event handlers via event.target
		event.target.pauseVideo();
  }
  
  getYoutubeId(url){
		url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
		return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
	}

  render() {
    const { dataLoaded, expanded } = this.state;
    const { programs, cats, programInfo, programWorkouts, getProgramWorkoutNotes, clientEmail, isViewProgramNotes } = this.props;
    const programId = this.props.editId;
    const queryParams = this.props.location ? new URLSearchParams(this.props.location.search) : null;
    const showMessage = queryParams ? queryParams.get('new') : false;
    if (dataLoaded) {
      const program = programInfo[programId];
      const category = Object.values(cats).filter((cat) => cat._id === program.categoryId)[0];
      const days = program['days'].sort((a, b) => a.day - b.day);
      let week = 1;
      let weekData = {};
      const day_filter = (day) => (day.week.toString() === week.toString());
      while (true) {
        let curWeek = days.filter((day) => day_filter(day));
        if (curWeek.length < 1) {
          break;
        }
        weekData[week] = Object.values(curWeek).map(curDay => (
          <div
            style={{
              justifyContent: 'space-between',
              padding: 5,
              height: 45,
              borderBottom: '3px solid ' + COLORS.grey
            }}
            className="listItem"
            key={'day-' + curDay.day} >
            <div style={{
              fontWeight: 'bold',
              width: '10%',
              borderRight: '1px solid ' + COLORS.grey,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <span style={{
                'margin': '5px'
              }}>{getWeekDayInitial(curDay.day)}</span>
            </div>
            <div style={{ width: '82%', margin: '0 10px 0 10px', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {this.displayDayInfo(curDay)}
            </div>
            <div
              style={{ width: '5%' }}>
              
              {
               curDay.type === 'workout' ? (
                  <WorkoutPreviewButton 
                    getProgramWorkoutNotes={getProgramWorkoutNotes} 
                    isViewProgramNotes={isViewProgramNotes} 
                    workout={programWorkouts[curDay.workoutId]} 
                    clientEmail = { clientEmail }
                  />
                ) : null
              }
            </div>
          </div>
        ))
        week++;
      }
      let videoId;
      if(program && program.youtubeLink) {
        videoId = this.getYoutubeId(program.youtubeLink);
      }
      const opts = {
        height: '200',
        width: '320',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
        },
      };
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
          {
            showMessage ? (
              <AlertMessage
                subject="Program added!"
                body={PROGRAM_ADDED_MESSAGE}
                icon={['far', 'check-square']}
              />
            ) : null
          }

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
          }}>

    {!program.youtubeLink && program.imgUrl &&
                (program.imgUrl.includes('.mp4') ||  program.imgUrl.includes('.quicktime') || program.imgUrl.includes('.MOV')) ? (
                  <video
                    src={program.imgUrl}
                    controls
                    style={{ width: '100%', height: 200, objectFit: 'fill' }}
                    autoPlay
                    loop
                    muted
                  />
                ) : 
                  !program.youtubeLink && (
                    <img src={program.imgUrl} alt={program.name} style={{ width: '100%', height: 200, objectFit: 'fill' }} />
                  )
               }
              {program.youtubeLink &&
                <YouTube videoId={videoId} opts={opts} onReady={this._onReady} />
              }
              
            
          </div>
          <div style={{
            backgroundColor: COLORS.greyFour,
            padding: 10,
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <div style={{
                width: 'fit-content',
                background: COLORS.greyThree,
                borderRadius: 2,
                padding: '3px 5px',
                color: COLORS.greyFour
              }}>
                {category.name}
              </div>
              <div style={{
                fontWeight: 'bold',
                textAlign: 'center'
              }}>
                {program.name}
              </div>
              <div style={{
                color: COLORS.orange
              }}>
                {`${program.weeks} weeks | ${program.price ? '$' + program.price : 'FREE'} | ${this.getProgramLevel(program.level)}`}    </div>
              <div style={{
                fontWeight: 'bold',
                marginTop: 10
              }}>
                Description
              </div>
              <div style={{ textAlign: 'left', wordBreak: 'break-word', width: '95%' }}>
                {program.description}
              </div>
            </div>

          </div>
          <hr />
          {Object.keys(weekData).map((week) => (
            <ExpansionPanel key={`week-${week}`}
              expanded={expanded.toString() === week.toString()}
              onChange={() => this.setState(state => ({ expanded: state.expanded === week ? 0 : week }))}>
              <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <span>Week {week}</span>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails style={{ flexDirection: 'column' }}>
                <List style={{ width: '100%' }}>
                  {weekData[week]}
                </List>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          ))}
        </div>
      );
    } else {
      return null;
    }

  }
}

export default Info;



// WEBPACK FOOTER //
// ./src/components/programs/Info.js